export default function () {
  document.querySelectorAll('[data-countdown]').forEach((el) => {
    const countdownTime = el.getAttribute('data-countdown')
    if (!countdownTime) return
    const ts = new Date(countdownTime).valueOf()
    setInterval(() => {
      const diff = ts - new Date().valueOf()

      const d = diff / 1000 / 60 / 60 / 24
      const h = (d % 1) * 24
      const m = (h % 1) * 60
      const s = (m % 1) * 60

      const output = [
        { value: d, label: d >= 2 ? ' days ' : ' day ', noPad: true },
        { value: h, label: 'h ' },
        { value: m, label: 'm ' },
        { value: s, label: 's' },
      ].reduce((str, t) => {
        if (Math.floor(t.value) === 0 && !str.length) return str
        if (t.noPad) {
          return `${str}${Math.floor(t.value).toString()}${t.label}`
        } else {
          return `${str}${Math.floor(t.value).toString().padStart(2, '0')}${
            t.label
          }`
        }
      }, '')

      el.textContent = diff < 0 ? 'now' : output
    }, 1000)
  })
}
